import { useMemo } from 'react';
import { useDeviceSelector } from 'js/store/hooks';
import { useDevicePublicAPI as useCoreDevicePublicAPI } from '@core/js/hooks/usePublicAPI/hooks/useDevicePublicAPI';

export const useDevicePublicAPI = () => {
    const device = useDeviceSelector();
    const coreMethods = useCoreDevicePublicAPI();

    return useMemo(() => {
        const { clientPlatform } = device;
        return {
            ...coreMethods,
            /**
             * Whether clientPlatform is download.
             * @memberOf Playtech.API.device
             * @function
             * @example
             * // 'true'
             * Playtech.API.device.isDownloadClient();
             */
            isDownloadClient: () => clientPlatform === 'download'
        };
    }, [coreMethods, device]);
};
